import type { RouteObject } from 'react-router';

import { editorialDetailRoute } from './detail/editorial-detail.route';
import { editorialEditRoute } from './edit/editorial-edit.route';
import { editorialRoute } from './index/editorial.route';
import { editorialNewRoute } from './new/editorial-new.route';

/**
 * The four editorial routes, aggregated. A multi-route feature exports a
 * **plural** `.routes.tsx`, so the file name alone tells the router to expect
 * an array.
 *
 * **Order is load-bearing.** `editorial/new` is declared before
 * `editorial/:postId`, or the authoring route resolves as a post whose
 * identifier happens to be the word «new» — and the reader meets a `404` on the
 * one route the list's primary action points at.
 *
 * There is no route for the review queue, and that is the decision rather than
 * an omission: the queue is `/editorial` filtered to «بانتظار المراجعة», and a
 * second route would rebuild the same table behind one condition.
 */
export const editorialRoutes: RouteObject[] = [
  editorialRoute,
  editorialNewRoute,
  editorialDetailRoute,
  editorialEditRoute,
];
